import React, { useRef, useState } from 'react'
import ALoader from 'views/pages/manage/common/a-loader';
import styles from "../styles.module.scss";
import ListComponent from './ListComponent';
import { Card } from "reactstrap";
import { getCreateUpdateReqBody } from '../constants';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from "views/pages/manage/common/constant";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';

const InvigilatorPaymentSlab = ({ slabId, rows, setRows, fetchDetails }) => {
  // const isCreatePermission = checkPermission(userPermissions, "C");
  // const isUpdatePermission = checkPermission(userPermissions, "U");
  const isCreatePermission = true;
  const isUpdatePermission = true;
  const [isLoading, setIsLoading] = useState(false);
  const listRef = useRef();
  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 0,
    totalPage: 0,
    totalRecords: 0,
  });
  const [currPageSize, setCurrentPageSize] = useState(50);


  const nextButtonHandler = (newPage, currPageSize) => {

  }

  const createHandler = async (rowData) => {
    try {
      setIsLoading(true);
      const req = getCreateUpdateReqBody(rowData);
      const res = await fetchAllPostPromisedData(`${endpoint?.vendorPaymentSlab?.operateSlab}/${slabId}/rows`,
        req,
        'post'
      );
      if (res?.code === 200) {
        successToast(res?.message);
        fetchDetails();
        listRef.current.stopEditing();
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }

  }

  const updateHandler = async (rowData) => {
    try {
      setIsLoading(true);
      const reqBody = getCreateUpdateReqBody(rowData);
      const res = await fetchAllPostPromisedData(`${endpoint?.vendorPaymentSlab?.operateSlab}/rows/${rowData?.id}`,
        reqBody,
        'put'
      );
      if (res?.code === 200) {
        successToast(res?.message);
        fetchDetails();
        listRef.current.stopEditing();
      }
      else {
        failureToast(res?.message);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  const createUpdateHandler = async (rowData) => {
    if (rowData?.isNew) {
      await createHandler(rowData);
    } else {
      await updateHandler(rowData);
    }
  };

  return (
    <div>
      {isLoading && <ALoader position="fixed" />}
      <Card className={`${styles['page-container']}`}>
        <div className="d-flex justify-content-between align-items-start">
          <div className={`${styles['header-bar']}`}>
            <div className="ml-3 heading-4 color-dark">Payment slabs</div>
          </div>
          <div>
            {isCreatePermission && <AButton
              variant="primary_filled"
              size="xs"
              onClick={() => listRef?.current?.addNewRow()}
            >
              Add Slab
            </AButton>
            }
          </div>
        </div>

        <ListComponent
          currentPage={paginationInfo?.currentPage}
          currPageSize={currPageSize}
          ref={listRef}
          rows={rows}
          isLoading={isLoading}
          createUpdateHandler={createUpdateHandler}
          isUpdatePermission={isUpdatePermission}
          nextButtonHandler={nextButtonHandler}
        />

      </Card>
    </div>
  )
}

export default InvigilatorPaymentSlab;